/**
 * SS SWAP - Reglas compartidas de las citas con varios servicios (Sprint 31).
 * Los límites coinciden con backend/src/utils/citasServicios.js.
 */
export const MAX_SERVICIOS_CITA = 10;
export const MAX_DESCRIPCION_CITA = 500;
export const MIN_DESCRIPCION_SOLA = 5;
export const DURACION_DEFECTO_MIN = 60;

export function formatearDuracion(min) {
    const m = Number(min);
    if (!m) return '';
    if (m < 60) return `${m} min`;
    const h = Math.floor(m / 60);
    const r = m % 60;
    return r ? `${h} h ${r} min` : `${h} h`;
}

/**
 * Totales de una lista de servicios: duración conjunta (los que no tienen
 * duración usan la del taller por defecto, igual que el servidor), precio
 * referencial sumado y si alguno se cotiza en el taller (precio 0 o vacío).
 */
export function totalesServicios(servicios = []) {
    const duracion = servicios.length
        ? servicios.reduce((t, s) => t + (Number(s.duracion_estimada_min ?? s.duracion_min) || DURACION_DEFECTO_MIN), 0)
        : 0;
    const precios = servicios.map(s => Number(s.precio_base ?? s.precio_referencial) || 0);
    return {
        duracion,
        precio: precios.reduce((t, p) => t + p, 0),
        porCotizar: precios.some(p => p <= 0),
    };
}

/** Mensaje de error de la selección, o '' si es válida. */
export function validarSeleccion({ ids, otro, descripcion }) {
    const texto = (descripcion || '').trim();
    if (texto.length > MAX_DESCRIPCION_CITA) return `La descripción admite hasta ${MAX_DESCRIPCION_CITA} caracteres.`;
    if (/<\s*\/?\s*[a-z!?][^>]*>/i.test(texto)) return 'La descripción no puede contener etiquetas HTML.';
    if (ids.length > MAX_SERVICIOS_CITA) return `Puedes elegir hasta ${MAX_SERVICIOS_CITA} servicios por cita.`;
    if (!ids.length && !otro && !texto) return 'Elige al menos un servicio o describe el mantenimiento que necesitas.';
    if (otro && !texto) return 'Describe el otro mantenimiento o servicio que necesitas.';
    if (!ids.length && texto.length < MIN_DESCRIPCION_SOLA) return `Describe un poco más el servicio (mínimo ${MIN_DESCRIPCION_SOLA} caracteres).`;
    return '';
}

/** Nombres de los servicios de una cita (lista nueva o campo viejo). */
export function nombresServiciosCita(cita) {
    const lista = Array.isArray(cita?.servicios) ? cita.servicios.map(s => s.nombre).filter(Boolean) : [];
    if (lista.length) return lista;
    return cita?.servicio_nombre && cita.servicio_nombre !== 'Otro servicio' ? [cita.servicio_nombre] : [];
}

/** Título corto de una cita: "Frenos", "3 servicios", "2 servicios + otro" u "Otro servicio". */
export function tituloServiciosCita(cita) {
    const n = nombresServiciosCita(cita);
    const otro = Boolean(cita?.descripcion_adicional);
    if (!n.length) return 'Otro servicio';
    const base = n.length > 1 ? `${n.length} servicios` : n[0];
    return otro ? `${base} + otro` : base;
}
